import { type InputHTMLAttributes, forwardRef } from "react"
import { Search } from "lucide-react"
import { Input } from "../ui/input"
import { cn } from "../../lib/cn"

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Clases del contenedor (ancho, márgenes); las del input van en className */
  containerClassName?: string
}

/**
 * Campo de búsqueda homologado: lupa + input con padding garantizado.
 *
 * Razón de existir: cada página posicionaba la lupa a mano sobre un input con
 * padding distinto, y las utilidades de Tailwind v4 (en @layer) pierden contra
 * el CSS Velzon sin layer (.form-control impone su padding) → la lupa se
 * encimaba al texto según la vista. Aquí el icono es pointer-events-none,
 * centrado verticalmente, y el padding-left va con `!` para ganar cualquier
 * cascada. API = input nativo (value/onChange/placeholder/onKeyDown...).
 */
const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ containerClassName, className, type, ...props }, ref) => {
    return (
      <div className={cn("relative", containerClassName)}>
        <Search
          aria-hidden="true"
          className="pointer-events-none absolute left-3 top-1/2 z-[1] h-4 w-4 -translate-y-1/2 text-muted-foreground"
        />
        <Input
          ref={ref}
          type={type ?? "search"}
          className={cn("!pl-9", className)}
          {...props}
        />
      </div>
    )
  },
)
SearchInput.displayName = "SearchInput"

export { SearchInput }
